export default __webpack_public_path__ + "static/media/iconeHtml.1d8e08fd.svg";